// extracted by mini-css-extract-plugin
export var insideContainer = "futurePlans-module--insideContainer--uCajF";
export var insideContainerElement = "futurePlans-module--insideContainerElement--Zszf4";
export var insideContainerElementTitle = "futurePlans-module--insideContainerElementTitle--Rs+AV";
export var insideContainerElementUnique = "futurePlans-module--insideContainerElementUnique--Qe2pd";
export var bold = "futurePlans-module--bold--6Jhsd";
export var title = "futurePlans-module--title--GOsG0";
export var futurePlansImage = "futurePlans-module--futurePlansImage--+wH6Y";
export var center = "futurePlans-module--center--GV9Pz";
export var anchor = "futurePlans-module--anchor--RNi3g";